import { HttpRequest } from "@angular/common/http";

const AUTHORIZATION_HEADER_KEY = "Authorization";
const BEARER_PREFIX = "Bearer ";

/**
 * Extracts the Bearer token from the Authorization header of an HTTP request.
 *
 * @param request - The Angular HttpRequest object.
 * @returns The token string if found, otherwise `null`.
 */
export function getBearerTokenFromRequest(
  request: HttpRequest<any>,
): string | null {
  const authHeader = request.headers.get(AUTHORIZATION_HEADER_KEY);
  return authHeader && authHeader.startsWith(BEARER_PREFIX)
    ? authHeader.substring(BEARER_PREFIX.length)
    : null;
}

/**
 * Adds or replaces the 'Authorization: Bearer <token>' header in an HTTP request.
 *
 * @param request - The original HttpRequest object.
 * @param token - The raw token string (without 'Bearer ').
 * @returns A cloned HttpRequest with the Authorization header set, or the original request if no token is provided.
 */
export function getRequestWithBearerToken(
  request: HttpRequest<any>,
  token?: string | null,
): HttpRequest<any> {
  return token
    ? request.clone({
        setHeaders: { [AUTHORIZATION_HEADER_KEY]: `${BEARER_PREFIX}${token}` },
      })
    : request;
}
